import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@arc/frontend/util-query';
import { EditCleanupTask, ListCleanupTasks } from '@arc/shared/util-arc-cleanup';
const keys = {
  all: ['arc-cleanup'],
  allLists: () => [...keys.all, 'list'],
  list: query => [...keys.allLists(), query],
  allDetails: () => [...keys.all, 'detail'],
  detail: cleanupTaskId => [...keys.allDetails(), cleanupTaskId]
};
export function useQueryListCleanupTasks(query, enabled = true) {
  return useQuery({
    queryKey: keys.list(query),
    queryFn: ({
      signal
    }) => apiRequest(ListCleanupTasks, {
      query
    }, {
      signal
    }),
    enabled
  });
}
export function useCleanupTasksCount(enabled = true) {
  return useQuery({
    queryKey: [...keys.allLists(), 'count'],
    queryFn: ({
      signal
    }) => apiRequest(ListCleanupTasks, {
      query: {
        page: 0,
        itemsPerPage: 1,
        search: '',
        sort: 'createdAt',
        sortDirection: 'desc',
        filter: {
          status: ['QUEUED'],
          deleteAtType: 'next-P3D',
          deleteAtRangeStart: '',
          deleteAtRangeEnd: ''
        }
      }
    }, {
      signal
    }),
    enabled,
    select: data => data?.meta?.totalItems ?? 0,
    // Refetch every 30 seconds to keep count updated
    refetchInterval: 30_000
  });
}
async function editCleanupTask(cleanupTaskId, dto, queryClient) {
  const data = await apiRequest(EditCleanupTask, {
    params: {
      arcCleanupId: cleanupTaskId
    },
    body: dto
  });
  void queryClient.invalidateQueries({
    queryKey: keys.allLists()
  });
  void queryClient.invalidateQueries({
    queryKey: keys.detail(cleanupTaskId)
  });
  return data;
}
export function useMutationEditCleanupTask() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      cleanupTaskId,
      dto
    }) => editCleanupTask(cleanupTaskId, dto, queryClient)
  });
}